<script setup>
import router from '../../routes/index';
const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const goBack = () => {
  if (props.backUrl !== '') {
    router.push(props.backUrl);
  } else {
    router.go(-1);
  }
};

const buttonStyleClass = props.compact ? 'text-sm' : 'text-base';
</script>

<template>
  <!-- BonBoZ: duoi 640px chi con mui ten. Chu "Tro ve" an gan 60px be ngang cua
       thanh tieu de hoi thoai va bi be xuong hai dong, day chieu cao header len
       — trong khi mui ten quay lai la thu ai cung hieu tren dien thoai. Nhan
       van o `aria-label` cho trinh doc man hinh. -->
  <button
    class="flex items-center p-0 font-normal cursor-pointer shrink-0 whitespace-nowrap text-n-slate-11"
    :class="buttonStyleClass"
    :aria-label="buttonLabel || $t('GENERAL_SETTINGS.BACK')"
    @click.capture="goBack"
  >
    <i class="i-lucide-chevron-left -ml-1 text-lg" />
    <span class="hidden sm:inline">
      {{ buttonLabel || $t('GENERAL_SETTINGS.BACK') }}
    </span>
  </button>
</template>
